import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mainNav" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "navElement"
}

import { computed, inject, ref } from "vue";
import NavigationDrawer from "./NavigationDrawer.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNav',
  setup(__props) {

const displayWidth: any = inject(`displayWidth`);
const store: any = inject(`store`);
const router: any = inject(`router`);
const anchorList = store.getters.getNavAnchorList;
const drawer = ref(false);

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

function sendTo(to: string) {
  if (router.currentRoute.value.path !== `/home`) {
    router.go(-1);
  }
  drawer.value = false;
  setTimeout(() => {
    store.dispatch(`scrollToAction`, to);
  }, 10);
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAnchor = _resolveComponent("BaseAnchor")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sendTo(`about`))),
        class: "navLogo"
      }, [
        _createElementVNode("img", {
          src: require(`../assets/Vector.png`),
          alt: "Positivus Logo",
          class: "navLogoImage"
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          src: require(`../assets/Positivus.png`),
          alt: "Positivus Logo",
          class: "navLogoText"
        }, null, 8, _hoisted_3)
      ]),
      (!computedDisplayWidth.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(anchorList), (anchor) => {
              return (_openBlock(), _createBlock(_component_BaseAnchor, {
                class: "navAnchors",
                theme: "black",
                text: anchor.text,
                key: anchor.text,
                onClick: ($event: any) => (sendTo(anchor.to))
              }, null, 8, ["text", "onClick"]))
            }), 128)),
            _createVNode(_component_BaseButton, {
              color: "white",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sendTo(`contact`))),
              text: "Request a quote"
            })
          ]))
        : _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            icon: "mdi-view-headline",
            color: "black",
            size: "45",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (drawer.value = !drawer.value))
          }, null, 512)), [
            [_directive_ripple]
          ])
    ]),
    _createVNode(_Transition, { name: "drawer" }, {
      default: _withCtx(() => [
        (drawer.value && computedDisplayWidth.value)
          ? (_openBlock(), _createBlock(NavigationDrawer, {
              key: 0,
              onSendToEmit: sendTo,
              onWheel: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onTouchmove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              onScroll: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "backdrop" }, {
      default: _withCtx(() => [
        (drawer.value && computedDisplayWidth.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "backdrop",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (drawer.value = false)),
              onWheel: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
              onTouchmove: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
              onScroll: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
            }, null, 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})